import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TranslateModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  // private translateService = inject(TranslateService);

  constructor() {
    // const translate = inject(TranslateService);
    // this.translateService.setDefaultLang('fr');
    // this.translateService.use('fr');
  }
}
